import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { HorizontalStack, Stack, TitleAndAround, Total } from "../../Books/Order/BooksOrderProductItem";
import React from "react";
import { OrderCardContainer } from "./PaymentCard";
export const ProductCard = (param)=>{
    let { price , title  } = param;
    return /*#__PURE__*/ _jsx(OrderCardContainer, {
        children: /*#__PURE__*/ _jsxs(Stack, {
            children: [
                /*#__PURE__*/ _jsx(HorizontalStack, {
                    children: /*#__PURE__*/ _jsx(Stack, {
                        children: /*#__PURE__*/ _jsx(HorizontalStack, {
                            children: /*#__PURE__*/ _jsx(TitleAndAround, {
                                children: /*#__PURE__*/ _jsx("dt", {
                                    children: title
                                })
                            })
                        })
                    })
                }),
                /*#__PURE__*/ _jsxs(Total, {
                    children: [
                        /*#__PURE__*/ _jsx("dt", {
                            children: "판매가"
                        }),
                        /*#__PURE__*/ _jsxs("dd", {
                            className: "amount",
                            children: [
                                price.toLocaleString(),
                                "원"
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
